export default "__VITE_ASSET__DCVZphi$__"